import React from "react";
import { Container, Row, Table } from "react-bootstrap";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import DropdownMenu from "presentation/components/dropdown-menu/menu";
import { DROPDOWN_MENU_TYPE_ITEM } from 'presentation/model/constants';

import { CalendarCheck, InfoLg } from 'react-bootstrap-icons';

import integrationStatusService from "presentation/services/integration-status";
import eventAttendancesService from "presentation/services/event-attendances";

import ImportClassroomAttendanceModal from "presentation/pages/integrations/elements/import-classroom-attendance-modal";

class IntegrationsMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        classroomAttendanceFile: undefined,
      },
      loading: false,
      actionLoading: false,
      error: false,
      message: '',
      showAttendanceImportModal: false,
      showAttendaceImportStatusModal: false,
      importClassroomAttendanceStatusDescription: ' '
    };
    this.closeAttendanceImportModal = this.closeAttendanceImportModal.bind(this);
    this.closeAttendaceImportStatusModal = this.closeAttendaceImportStatusModal.bind(this);
  }

  openAttendanceImportModal = () => {
    this.setState({ showAttendanceImportModal: true });
  }

  sendClassroomAttendanceFileToProcessing = async () => {
    const { classroomAttendanceFile } = this.state.form;

    if (classroomAttendanceFile) {
      this.setState({ loading: true, actionLoading: true });

      try {
        const formData = new FormData();
        formData.append("file", classroomAttendanceFile);

        await eventAttendancesService.importClassroomAttendance(formData);

        this.setState({
          loading: false,
          actionLoading: false,
          showAttendanceImportModal: false,
          form: { ...this.state.form, classroomAttendanceFile: undefined }
        });

        await this.openAttendaceImportStatusModal();
      } catch (ex) {
        this.setState({ loading: false, actionLoading: false, error: true, message: "Erro ao processar arquivo." });
      }
    }
  }

  closeAttendanceImportModal = () => {
    this.setState({ showAttendanceImportModal: false, form: { ...this.state.form, classroomAttendanceFile: undefined } });
  }

  openAttendaceImportStatusModal = async () => {
    this.setState({ loading: true });

    await integrationStatusService.getImportClassroomAttendanceStatus().then((result) => {
      const { inQueue, processing, timestamp } = result;
      let description = ' ';

      if (timestamp) {
        description = `Itens <strong>na fila</strong>: ${inQueue}.<br />Itens em <strong>processamento</strong>: ${processing}`;
      }

      this.setState({ loading: false, importClassroomAttendanceStatusDescription: description });
    });

    this.setState({ showAttendaceImportStatusModal: true });
  }

  closeAttendaceImportStatusModal = () => {
    this.setState({ showAttendaceImportStatusModal: false, importClassroomAttendanceStatusDescription: ' ' });
  }

  render() {
    let { location } = this.props;

    const { loading, actionLoading, error, message, data, showAttendanceImportModal, showAttendaceImportStatusModal, importClassroomAttendanceStatusDescription } = this.state;

    const { openAttendanceImportModal, openAttendaceImportStatusModal } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <h4>Integrações</h4>
              <Container>
                <Table className="mt-4">
                  <tbody>
                    <tr>
                      <td>Importação de entrada e saída dos alunos (frequência por dia)</td>
                      <td className="text-end">
                        <DropdownMenu
                          items={[
                            { type: DROPDOWN_MENU_TYPE_ITEM, title: <><CalendarCheck /> Enviar arquivo</>, props: { onClick: () => openAttendanceImportModal() } },
                            { type: DROPDOWN_MENU_TYPE_ITEM, title: <><InfoLg /> Status da importação</>, props: { onClick: async () => await openAttendaceImportStatusModal() } }
                          ]}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>

                {/* Modal de Status */}
                {showAttendaceImportStatusModal === true && (
                  <PageModal
                    title="Status da importação"
                    show={showAttendaceImportStatusModal}
                    confirmText="Ok"
                    onConfirm={this.closeAttendaceImportStatusModal}
                    description={importClassroomAttendanceStatusDescription}
                  />)
                }

                {/* Inclusão do Modal de Importação */}
                {showAttendanceImportModal === true && (
                  <ImportClassroomAttendanceModal
                    show={showAttendanceImportModal}
                    onClose={this.closeAttendanceImportModal}
                    onSubmit={this.sendClassroomAttendanceFileToProcessing}
                    component={this}
                  />
                )}
              </Container>
            </Row>
          </Container>
        )}
      </div>
    );
  };
}

export default IntegrationsMain;